import { Row, Table } from '@tanstack/react-table';

import Checkbox from 'components/Checkbox/Checkbox';

export const SELECT_ALL_ROWS_ID = 'select-all-rows';

export function geTableSelectionColumn(isDisabled?: boolean) {
  return {
    id: SELECT_ALL_ROWS_ID,
    header: ({ table }: { table: Table<any> }) => (
      <Checkbox
        checked={
          table.getIsAllRowsSelected()
            ? true
            : table.getIsSomeRowsSelected()
              ? 'indeterminate'
              : false
        }
        onCheckedChange={(checked) => table.toggleAllRowsSelected(!!checked)}
        isDisabled={isDisabled}
      />
    ),
    cell: ({ row }: { row: Row<any> }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(checked) => row.toggleSelected(!!checked)}
        isDisabled={isDisabled}
      />
    ),
    size: 50
  };
}
